(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["affiliate-badge"] && !Shopify.designMode) return;
  try {
    class AffiliateBadge extends HTMLElement {
    connectedCallback() {
      this.render = this.render.bind(this);
      document.addEventListener('affiliate:ready', this.render);
      this.render();
    }

    disconnectedCallback() {
      document.removeEventListener('affiliate:ready', this.render);
    }

    // Everything shown is text from the session store; the avatar is the one https address the script accepted.
    render() {
      let data = null;
      try { data = JSON.parse(window.sessionStorage.getItem('affiliate')); } catch (error) { data = null; }
      if (!data || typeof data.name !== 'string' || data.name === '' || typeof data.value !== 'number' || !(data.value > 0)) return;
      this.querySelector('[data-badge-title]').textContent = this.dataset.titleTemplate.split('[name]').join(data.name);
      const percent = this.querySelector('[data-badge-percent]');
      const amount = this.querySelector('[data-badge-amount]');
      if (data.type === 'amount') {
        window.theme.price.update(amount.querySelector('[data-price-live]'), { price: Math.round(data.value * 100) });
      } else {
        percent.textContent = this.dataset.percentTemplate.split('[value]').join(`${data.value}`.replace('.', this.dataset.decimal));
      }
      percent.hidden = data.type === 'amount';
      amount.hidden = data.type !== 'amount';
      const avatar = this.querySelector('[data-badge-avatar]');
      if (typeof data.avatar === 'string' && /^https:\/\/[^\s"'<>\\]+$/.test(data.avatar)) {
        avatar.src = data.avatar;
        avatar.hidden = false;
      }
      this.hidden = false;
    }
  }

  customElements.define('affiliate-badge', AffiliateBadge);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["c-back-in-stock"] && !Shopify.designMode) return;
  try {
    class BackInStock extends HTMLElement {
    // Deliberately narrow: one @, one dot behind it, no space, no angle bracket.
    static EMAIL = /^[^\s@<>"]+@[^\s@<>".]+\.[^\s@<>".]{2,}$/;

    connectedCallback() {
      this.form = this.querySelector('[data-signup-form]');
      this.email = this.querySelector('[data-signup-email]');
      this.consent = this.querySelector('[data-signup-consent]');
      this.done = this.querySelector('[data-signup-done]');
      this.error = this.querySelector('[data-signup-error]');
      if (!this.form) return;
      this.form.hidden = false;
      this.form.addEventListener('submit', (event) => this.submit(event));
    }

    show(element, text) {
      if (text !== undefined) element.textContent = text;
      element.hidden = false;
    }

    async submit(event) {
      event.preventDefault();
      const address = this.email.value.trim();
      this.error.hidden = true;
      if (!BackInStock.EMAIL.test(address) || !this.consent.checked) {
        this.show(this.error, this.form.dataset.invalid);
        return;
      }
      const url = `${this.dataset.endpoint}?company_id=${encodeURIComponent(this.dataset.company)}`;
      const body = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email: address } } } },
          relationships: { variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${this.dataset.variant}` } } },
        },
      };
      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: this.dataset.revision },
          body: JSON.stringify(body),
        });
        if (!response.ok) throw new Error(String(response.status));
        this.form.hidden = true;
        this.show(this.done);
      } catch (failure) {
        this.show(this.error, this.form.dataset.error);
      }
    }
  }

  customElements.define('back-in-stock', BackInStock);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["c-bundle-builder"] && !Shopify.designMode) return;
  try {
    class BundleBuilder extends HTMLElement {
    connectedCallback() {
      // theme.js is deferred too; whichever script runs first, both are there once the document is parsed.
      if (window.theme) this.start();
      else document.addEventListener('DOMContentLoaded', () => window.theme && this.start(), { once: true });
    }

    start() {
      const root = this.closest('.c-bundle-builder');
      this.items = new Map();
      this.busy = false;
      this.sizes = [...root.querySelectorAll('[data-size]')]
        .map((element) => ({ element, quantity: Number(element.dataset.quantity), percent: Number(element.dataset.percent) }))
        .filter((size) => size.quantity > 0 && size.percent >= 0 && size.percent <= 100)
        .sort((a, b) => a.quantity - b.quantity);
      if (this.sizes.length === 0) return;

      this.lines = this.querySelector('[data-lines]');
      this.price = this.querySelector('[data-price-live]');
      this.button = this.querySelector('[data-submit]');
      this.addEventListener('click', (event) => this.onClick(event));
      root.querySelector('[data-bundle-fallback]').hidden = true;
      this.hidden = false;
      this.render();
    }

    onClick(event) {
      // The box is emptied after the purchase, so a change made meanwhile would be lost.
      if (this.busy) return;
      const target = (selector) => event.target.closest(selector);
      if (target('[data-add]')) {
        const { variantId, price, title } = target('[data-card]').dataset;
        const item = this.items.get(variantId) ?? { price: Number(price), title, quantity: 0 };
        item.quantity += 1;
        this.items.set(variantId, item);
      } else if (target('[data-step]')) {
        const id = target('[data-line]').dataset.line;
        const item = this.items.get(id);
        item.quantity += Number(target('[data-step]').dataset.step);
        if (item.quantity < 1) this.items.delete(id);
      } else if (target('[data-remove]')) {
        this.items.delete(target('[data-line]').dataset.line);
      } else if (target('[data-submit]')) {
        this.submit();
        return;
      } else {
        return;
      }
      const focused = target('[data-step], [data-remove]');
      const restore = focused && { line: target('[data-line]').dataset.line, selector: focused.dataset.step ? `[data-step="${focused.dataset.step}"]` : '[data-remove]' };
      this.render();
      if (restore) (this.lines.querySelector(`[data-line="${restore.line}"] ${restore.selector}`) ?? this.querySelector('[data-add]'))?.focus();
    }

    // Each line is discounted on its own and rounded half up, as a percentage discount lands on cart lines.
    totals() {
      const items = [...this.items.values()];
      const quantity = items.reduce((sum, item) => sum + item.quantity, 0);
      const step = [...this.sizes].reverse().find((size) => quantity >= size.quantity);
      const percent = step?.percent ?? 0;
      const subtotal = items.reduce((sum, item) => sum + item.price * item.quantity, 0);
      const savings = items.reduce((sum, item) => sum + Math.floor((item.price * item.quantity * percent * 10 + 500) / 1000), 0);
      return { quantity, percent, subtotal, savings, next: this.sizes.find((size) => size.quantity > quantity) };
    }

    render() {
      const { quantity, percent, subtotal, savings, next } = this.totals();
      const template = this.querySelector('[data-line-template]');
      this.lines.replaceChildren(
        ...[...this.items].map(([id, item]) => {
          const line = template.content.firstElementChild.cloneNode(true);
          line.dataset.line = id;
          line.querySelector('[data-line-title]').textContent = item.title;
          line.querySelector('[data-line-quantity]').textContent = item.quantity;
          for (const control of line.querySelectorAll('[data-label]')) control.setAttribute('aria-label', control.dataset.label.replace('[title]', item.title));
          return line;
        }),
      );
      this.querySelector('[data-empty]').hidden = quantity > 0;
      this.querySelector('[data-total]').hidden = quantity === 0;
      window.theme.price.update(this.price, { price: subtotal - savings, compareAtPrice: subtotal, savings });

      const meter = this.querySelector('[data-meter]');
      meter.max = this.sizes[this.sizes.length - 1].quantity;
      meter.value = Math.min(quantity, meter.max);
      for (const size of this.sizes) size.element.toggleAttribute('data-reached', quantity >= size.quantity);
      const progress = this.querySelector('[data-progress]');
      // A percentage like 12.5 reads "12,5" where the language writes a comma.
      const fill = (text, values) => Object.entries(values).reduce((out, [name, value]) => out.replace(`[${name}]`, `${value}`.replace('.', this.dataset.decimal)), text);
      if (next) progress.textContent = fill(progress.dataset.next, { count: next.quantity - quantity, percent: next.percent });
      else progress.textContent = fill(progress.dataset.complete, { percent });

      const missing = this.sizes[0].quantity - quantity;
      this.button.disabled = this.busy || missing > 0;
      if (this.busy) this.button.textContent = this.button.dataset.busy;
      else this.button.textContent = missing > 0 ? fill(this.button.dataset.more, { count: missing }) : this.button.dataset.ready;
    }

    async submit() {
      const status = this.querySelector('[data-status]');
      const error = this.querySelector('[data-error]');
      // One group id per box keeps two boxes in the same cart apart.
      const group = `g${Date.now().toString(36)}${Math.random().toString(36).slice(2, 8)}`;
      const items = [...this.items].map(([id, item]) => ({ id: Number(id), quantity: item.quantity, properties: window.theme.markers({ bundle: this.dataset.bundleKey, bundle_group: group }) }));
      status.replaceChildren();
      error.textContent = '';
      this.busy = true;
      this.render();
      try {
        await window.theme.cart.add({ items }, 'bundle-builder');
        this.items.clear();
        status.replaceChildren(this.querySelector('[data-added]').content.cloneNode(true));
      } catch (failure) {
        error.textContent = (failure instanceof window.theme.CartError && failure.message) || error.dataset.fallback;
      } finally {
        this.busy = false;
        this.render();
      }
    }
  }

  customElements.define('bundle-builder', BundleBuilder);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["c-countdown"] && !Shopify.designMode) return;
  try {
    class CountDown extends HTMLElement {
    static PARTS = ['days', 'hours', 'minutes', 'seconds'];

    connectedCallback() {
      this.ends = Number(this.dataset.ends) * 1000;
      this.clock = this.querySelector('[data-countdown-clock]');
      this.date = this.querySelector('[data-countdown-date]');
      this.parts = {};
      for (const name of CountDown.PARTS) this.parts[name] = this.querySelector(`[data-countdown-part="${name}"]`);
      if (!this.ends || !this.clock) return;
      // The date stays for screen readers, the clock takes the visible place.
      this.date.classList.add('visually-hidden');
      this.clock.hidden = false;
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    // The end is a fixed moment: once it has passed the counter goes away, it never restarts.
    tick() {
      const left = Math.floor((this.ends - Date.now()) / 1000);
      if (left <= 0) {
        clearInterval(this.timer);
        this.hidden = true;
        return;
      }
      this.parts.days.textContent = Math.floor(left / 86400);
      this.parts.hours.textContent = Math.floor(left / 3600) % 24;
      this.parts.minutes.textContent = Math.floor(left / 60) % 60;
      this.parts.seconds.textContent = left % 60;
    }
  }

  customElements.define('count-down', CountDown);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["c-hero-slider"] && !Shopify.designMode) return;
  try {
    class HeroSlider extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('[data-track]');
      const nav = this.querySelector('[data-nav]');
      if (!track || !nav || track.children.length < 2) return;

      nav.hidden = false;
      nav.addEventListener('click', (event) => {
        const button = event.target.closest('[data-step]');
        if (!button) return;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollBy({ left: Number(button.dataset.step) * track.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
      });
    }
  }

  customElements.define('hero-slider', HeroSlider);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["c-offer-cards"] && !Shopify.designMode) return;
  try {
    class OfferCards extends HTMLElement {
    connectedCallback() {
      this.options = Array.from(this.querySelectorAll('[data-offer-option]'));
      this.slots = Array.from(this.querySelectorAll('[data-offer-cta-price], [data-sticky-offer-price]'));
      this.separators = Array.from(this.querySelectorAll('[data-offer-separator]'));
      this.names = Array.from(this.querySelectorAll('[data-sticky-offer-name]'));
      if (this.options.length > 0) {
        this.addEventListener('change', () => this.show());
        this.show();
      }
      this.count();
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    show() {
      const chosen = this.options.find((option) => option.checked) || this.options[0];
      const card = chosen.closest('li');
      const price = card && card.querySelector('[data-offer-price]');
      const name = card && card.querySelector('[data-offer-name]');
      for (const slot of this.slots) {
        slot.replaceChildren(...(price ? Array.from(price.cloneNode(true).childNodes) : []));
        slot.hidden = !price;
      }
      for (const separator of this.separators) separator.hidden = !price;
      for (const slot of this.names) slot.textContent = name ? name.textContent : '';
    }

    // The end is a fixed moment out of the launch plan: once it has passed the line goes away.
    count() {
      this.boxes = Array.from(this.querySelectorAll('[data-launch-ends]'));
      this.rests = Array.from(this.querySelectorAll('[data-launch-rest]'));
      this.ends = this.boxes.length > 0 ? Number(this.boxes[0].dataset.launchEnds) * 1000 : 0;
      if (!this.ends || this.rests.length === 0) return;
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    tick() {
      const left = Math.floor((this.ends - Date.now()) / 1000);
      if (left <= 0) {
        clearInterval(this.timer);
        for (const box of this.boxes) box.hidden = true;
        return;
      }
      const units = this.dataset;
      const parts = [
        [Math.floor(left / 86400), units.unitDays],
        [Math.floor(left / 3600) % 24, units.unitHours],
        [Math.floor(left / 60) % 60, units.unitMinutes],
      ].filter(([value], index) => value > 0 || index > 0);
      const text = parts.map(([value, unit]) => `${value} ${unit}`).join(' ');
      for (const rest of this.rests) rest.textContent = text;
    }
  }

  customElements.define('offer-cards', OfferCards);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["c-package-picker"] && !Shopify.designMode) return;
  try {
    class PackagePicker extends HTMLElement {
    connectedCallback() {
      this.cta = this.querySelector('[data-cta]');
      this.label = this.querySelector('[data-cta-label]');
      this.shipping = this.querySelector('[data-shipping]');
      this.error = this.querySelector('[data-error]');
      this.upsell = this.querySelector('[data-upsell]');
      this.inputs = [...this.querySelectorAll('[data-package-option] input')];
      if (!this.cta || this.inputs.length === 0) return;
      if (!this.inputs.some((input) => input.checked)) this.inputs[0].checked = true;
      for (const input of this.inputs) input.addEventListener('change', () => this.update());
      this.upsell?.addEventListener('click', () => {
        const next = this.next();
        if (!next) return;
        next.checked = true;
        this.update();
      });
      this.cta.addEventListener('click', () => this.add());
      this.update();
    }

    chosen() {
      return this.inputs.find((input) => input.checked) ?? null;
    }

    next() {
      const chosen = this.chosen();
      return chosen ? this.inputs[this.inputs.indexOf(chosen) + 1] ?? null : null;
    }

    money(cents) {
      return window.theme?.formatMoney ? window.theme.formatMoney(cents, this.dataset.moneyFormat) : (cents / 100).toFixed(2);
    }

    update() {
      const chosen = this.chosen();
      if (!chosen) return;
      const price = Number(chosen.dataset.price);
      this.label.textContent = `${this.cta.dataset.label} • ${this.money(price)}`;

      const freeFrom = Number(this.dataset.freeFrom);
      if (freeFrom > 0) {
        this.shipping.textContent = price >= freeFrom
          ? this.dataset.shippingFree
          : this.dataset.shippingMissing.replace('{amount}', this.money(freeFrom - price));
      }

      // The hint offers the next package while it carries a hint of its own.
      const next = this.next();
      const lead = next?.dataset.upsellLead ?? '';
      if (this.upsell) {
        this.upsell.hidden = lead === '';
        if (lead !== '') {
          const nextPrice = Number(next.dataset.price);
          this.upsell.querySelector('[data-upsell-lead]').textContent = lead.replace('{diff}', this.money(nextPrice - price));
          this.upsell.querySelector('[data-upsell-text]').textContent = (next.dataset.upsellText ?? '')
            .replace('{price}', this.money(nextPrice))
            .replace('{compare}', this.money(Number(next.dataset.compare)));
        }
      }
    }

    async add() {
      const chosen = this.chosen();
      if (!chosen || this.cta.disabled || !window.theme) return;
      // A set package goes in as one box; its own group per add keeps two packages from merging into one line.
      const group = chosen.dataset.group ? `${chosen.dataset.group}-${Date.now().toString(36)}` : '';
      const items = chosen.dataset.variants.split(',').filter(Boolean).map((id) => {
        const item = { id: Number(id), quantity: 1 };
        if (group !== '') item.properties = window.theme.markers({ bundle_group: group });
        return item;
      });
      const before = this.label.textContent;
      this.cta.disabled = true;
      this.error.hidden = true;
      try {
        await window.theme.cart.add({ items }, 'package-picker');
      } catch (error) {
        this.error.hidden = false;
      } finally {
        this.cta.disabled = false;
        this.label.textContent = before;
      }
    }
  }

  if (!customElements.get('package-picker')) customElements.define('package-picker', PackagePicker);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["c-quick-buy"] && !Shopify.designMode) return;
  try {
    class QuickBuy extends HTMLElement {
    connectedCallback() {
      this.sheet = this.querySelector('[data-quick-sheet]');
      this.message = this.querySelector('[data-quick-error]');
      this.addEventListener('click', (event) => this.onClick(event));
      if (this.sheet) {
        this.sheet.addEventListener('click', (event) => {
          if (event.target === this.sheet) this.sheet.close();
        });
      }
    }

    // The control stays a link: without the cart module, a modifier click or a browser without <dialog> the product page answers.
    onClick(event) {
      const link = event.target.closest('[data-quick-buy]');
      const add = event.target.closest('[data-quick-add]');
      if (!window.theme || event.metaKey || event.ctrlKey || event.shiftKey) return;
      if (add) {
        this.submit(add);
      } else if (link && this.sheet) {
        if (typeof this.sheet.showModal !== 'function') return;
        event.preventDefault();
        this.sheet.showModal();
      } else if (link) {
        event.preventDefault();
        this.submit(link);
      }
    }

    chosen() {
      const variant = this.querySelector('[data-quick-variant]:checked');
      const plan = this.querySelector('[data-quick-plan]:checked');
      return { id: variant ? variant.value : this.dataset.variantId, plan: plan ? plan.value : '' };
    }

    async submit(button) {
      const { id, plan } = this.chosen();
      if (!id || button.getAttribute('aria-disabled') === 'true') return;
      const line = { id: Number(id), quantity: 1 };
      if (plan) line.selling_plan = Number(plan);
      const label = button.textContent;
      button.setAttribute('aria-disabled', 'true');
      button.textContent = this.dataset.adding;
      if (this.message) this.message.hidden = true;
      try {
        await window.theme.cart.add({ items: [line] }, 'quick-buy');
        if (this.sheet && this.sheet.open) this.sheet.close();
      } catch (failure) {
        if (failure instanceof window.theme.CartError && this.message) {
          this.message.textContent = failure.message || this.dataset.error;
          this.message.hidden = false;
        } else {
          window.location.assign(this.dataset.url);
        }
      } finally {
        button.textContent = label;
        button.removeAttribute('aria-disabled');
      }
    }
  }

  customElements.define('quick-buy', QuickBuy);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["c-sticky-buy"] && !Shopify.designMode) return;
  try {
    class StickyBuy extends HTMLElement {
    connectedCallback() {
      // The bar watches the button of the block it stands in: the buy box, or the offer cards of a launch.
      const scope = this.closest('[data-sticky-scope], [data-product-live]');
      const anchor = scope && scope.querySelector('[data-sticky-anchor]');
      if (!anchor) return;
      // An observer only fires where the button crosses an edge; a jump to the top crosses none and would leave the bar standing.
      this.follow = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.hidden = anchor.getBoundingClientRect().bottom > 0;
        });
      };
      addEventListener('scroll', this.follow, { passive: true });
      addEventListener('resize', this.follow, { passive: true });
      this.follow();
    }

    disconnectedCallback() {
      if (!this.follow) return;
      removeEventListener('scroll', this.follow);
      removeEventListener('resize', this.follow);
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  }

  customElements.define('sticky-buy', StickyBuy);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["c-video-tile"] && !Shopify.designMode) return;
  try {
    class VideoTile extends HTMLElement {
    connectedCallback() {
      const video = this.querySelector('video');
      const play = this.querySelector('button.c-video-tile__play');
      if (video === null || play === null) return;
      // Metadata draws the first frame as the poster; it waits until the row comes near, so no video competes with the top of the page.
      if (video.preload === 'none' && 'IntersectionObserver' in window) {
        const near = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          near.disconnect();
          video.preload = 'metadata';
          video.load();
        }, { rootMargin: '800px' });
        // The row scrolls sideways and clips its later tiles, so every tile waits for the row itself.
        near.observe(this.closest('.c-video-wall') ?? this);
      }
      play.addEventListener('click', () => {
        video.controls = true;
        play.hidden = true;
        video.play();
      });
      video.addEventListener('pause', () => {
        video.controls = false;
        play.hidden = false;
      });
    }
  }

  if (!customElements.get('video-tile')) customElements.define('video-tile', VideoTile);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-body"] && !Shopify.designMode) return;
  try {
    class CartItems extends HTMLElement {
    connectedCallback() {
      // theme.js is deferred too; whichever script runs first, both are there once the document is parsed.
      if (window.theme) this.start();
      else document.addEventListener('DOMContentLoaded', () => window.theme && this.start(), { once: true });
    }

    start() {
      if (this.started) return;
      this.started = true;
      // With script every change is sent at once, so the steppers appear and the update button has nothing left to do.
      for (const button of this.querySelectorAll('[data-cart-step]')) button.hidden = false;
      const update = this.querySelector('[data-cart-update]');
      if (update) update.hidden = true;

      this.addEventListener('click', (event) => {
        const step = event.target.closest('[data-cart-step]');
        if (!step || this.busy) return;
        const input = step.closest('[data-cart-line]').querySelector('[data-cart-quantity]');
        input.value = Math.max(0, (Number(input.value) || 0) + Number(step.dataset.cartStep));
        this.send(() => window.theme.cart.change({ id: this.keyOf(input), quantity: Number(input.value) }));
      });
      this.addEventListener('change', (event) => {
        const input = event.target;
        if (input.matches('[data-cart-quantity]')) {
          const quantity = Number(input.value);
          if (!Number.isInteger(quantity) || quantity < 0) return;
          this.send(() => window.theme.cart.change({ id: this.keyOf(input), quantity }));
        } else if (input.matches('[data-cart-note]')) {
          // Leaving the note for a stepper fires this first; it must not make the row ignore that click.
          window.theme.cart.update({ note: input.value }).catch(() => {});
        }
      });
      this.addEventListener('submit', (event) => {
        const form = event.target.closest('[data-cart-remove]');
        if (!form) return;
        event.preventDefault();
        const fields = [...form.querySelectorAll('input[type="hidden"]')];
        const keys = fields.filter((input) => input.name.startsWith('updates[')).map((input) => input.name.slice('updates['.length, -1));
        const attributes = Object.fromEntries(fields.filter((input) => input.name.startsWith('attributes[')).map((input) => [input.name.slice('attributes['.length, -1), input.value]));
        // A box or a package is several lines; one update call takes them all, so no half box is left behind.
        if (keys.length === 1 && Object.keys(attributes).length === 0) this.send(() => window.theme.cart.change({ id: keys[0], quantity: 0 }));
        else this.send(() => window.theme.cart.update({ updates: Object.fromEntries(keys.map((key) => [key, 0])), attributes }));
      });
    }

    keyOf(element) {
      return element.closest('[data-cart-line]').dataset.lineKey;
    }

    async send(call) {
      if (this.busy) return;
      this.busy = true;
      this.setAttribute('aria-busy', 'true');
      const host = this.closest('[data-cart-section]');
      try {
        await call();
      } catch (failure) {
        const message = (failure instanceof window.theme.CartError && failure.message) || this.dataset.error;
        // The rows may show a quantity the cart refused; Liquid renders the truth again before the message lands in it.
        await window.theme.cart.refresh().catch(() => {});
        const target = (host ?? this).querySelector('[data-cart-error]');
        if (target) target.textContent = message;
      } finally {
        this.busy = false;
        this.removeAttribute('aria-busy');
      }
    }
  }

  customElements.define('cart-items', CartItems);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-rewards"] && !Shopify.designMode) return;
  try {
    // Liquid decides which gift is due; these sets only keep one render from repeating a call the next render has not seen yet.
  const giftsAdding = new Set();
  const giftsRemoving = new Set();
  const giftsTrimming = new Set();

  class CartRewards extends HTMLElement {
    connectedCallback() {
      if (window.theme) this.start();
      else document.addEventListener('DOMContentLoaded', () => window.theme && this.start(), { once: true });
    }

    start() {
      if (this.started) return;
      this.started = true;
      this.addEventListener('submit', (event) => {
        const addon = event.target.closest('[data-cart-addon]');
        const form = event.target.closest('[data-set-offer]');
        if (!addon && !form) return;
        event.preventDefault();
        if (addon) this.addAddon(addon);
        else this.addSet(form);
      });
      this.syncGifts();
    }

    list(name) {
      const holder = this.querySelector('[data-gift-add]');
      return (holder?.dataset[`gift${name}`] ?? '').split(',').filter(Boolean);
    }

    // The theme only puts the gift line into the cart, marked with _gift; the discount function sets its price to zero.
    syncGifts() {
      const due = this.list('Add');
      const stale = this.list('Remove');
      const holder = this.querySelector('[data-gift-add]');
      const keys = (value) => (value ?? '').split(',').filter(Boolean);
      // A second line of the same gift leaves whole, a second piece in one line goes back to one.
      const fixes = [...keys(holder?.dataset.giftExtra).map((key) => [key, 0]), ...keys(holder?.dataset.giftTrim).map((key) => [key, 1])];
      for (const id of giftsAdding) if (!due.includes(id)) giftsAdding.delete(id);
      for (const key of giftsRemoving) if (!stale.includes(key)) giftsRemoving.delete(key);
      for (const key of giftsTrimming) if (!fixes.some(([candidate]) => candidate === key)) giftsTrimming.delete(key);

      // One change per render: the sections come back from Shopify and the next element takes the next step.
      const fix = fixes.find(([candidate]) => !giftsTrimming.has(candidate));
      if (fix) {
        giftsTrimming.add(fix[0]);
        window.theme.cart.change({ id: fix[0], quantity: fix[1] }, 'cart-rewards').catch(() => {});
        return;
      }
      const key = stale.find((candidate) => !giftsRemoving.has(candidate));
      if (key) {
        giftsRemoving.add(key);
        window.theme.cart.change({ id: key, quantity: 0 }, 'cart-rewards').catch(() => {});
        return;
      }
      // A gift that was refused stays in the set, so it is tried once per page and not on every change of the cart.
      const id = due.find((candidate) => !giftsAdding.has(candidate) && Number.isSafeInteger(Number(candidate)));
      if (id) {
        giftsAdding.add(id);
        window.theme.cart.add({ items: [{ id: Number(id), quantity: 1, properties: window.theme.markers({ gift: 'true' }) }] }, 'cart-rewards').catch(() => {});
      }
    }

    // One piece of the add-on, marked with its offer; the discount function sets its price, the render after the add shows no second one.
    async addAddon(form) {
      if (this.busy) return;
      this.busy = true;
      const button = form.querySelector('[type="submit"]');
      button.disabled = true;
      const id = Number(form.querySelector('[name="id"]').value);
      try {
        await window.theme.cart.add({ items: [{ id, quantity: 1, properties: window.theme.markers({ upsell: form.dataset.cartAddon }) }] }, 'cart-addon');
      } catch (failure) {
        const target = form.querySelector('[data-addon-error]');
        target.textContent = (failure instanceof window.theme.CartError && failure.message) || this.dataset.error;
        button.disabled = false;
      } finally {
        this.busy = false;
      }
    }

    async addSet(form) {
      if (this.busy) return;
      this.busy = true;
      const button = form.querySelector('[type="submit"]');
      button.disabled = true;
      const ids = [...form.querySelectorAll('[data-set-id]')];
      const items = ids.map((input) => ({ id: Number(input.value), quantity: Number(input.dataset.setQuantity) }));
      try {
        await window.theme.cart.add({ items }, 'cart-rewards');
      } catch (failure) {
        const target = form.querySelector('[data-set-error]');
        target.textContent = (failure instanceof window.theme.CartError && failure.message) || this.dataset.error;
        button.disabled = false;
      } finally {
        this.busy = false;
      }
    }
  }

  customElements.define('cart-rewards', CartRewards);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-upsell"] && !Shopify.designMode) return;
  try {
    // One request per address and page view: every render of the cart puts the same recommendations back without asking again.
  const upsellPages = new Map();

  class CartUpsell extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-upsell-list]');
      // happyhug: Karten eines Test-Arms (Bundle vorne im Arm „upgrade“) zählen nur, wo sie zu sehen sind; sonst fallen
      // sie aus dem Slider, damit Punkte und Wischen stimmen.
      for (const item of [...this.list.children]) {
        if (getComputedStyle(item).display === 'none') item.remove();
      }
      this.leads = [...this.list.querySelectorAll('[data-upsell-lead]')];
      if (this.list.children.length === 0 && !this.dataset.recommend) this.hidden = true;
      this.addEventListener('submit', (event) => {
        const form = event.target.closest('[data-upsell-form]');
        if (!form || !window.theme) return;
        event.preventDefault();
        this.add(form);
      });
      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-upsell-variant]')) this.choose(event.target);
      });
      this.addEventListener('click', (event) => {
        const dot = event.target.closest('[data-upsell-dot]');
        if (dot) this.show(Number(dot.dataset.upsellDot));
      });
      this.list.addEventListener('scroll', () => this.mark(), { passive: true });
      // A card changes height when its picture arrives or the drawer narrows; the row follows the one in view.
      this.sizes = 'ResizeObserver' in window ? new ResizeObserver(() => this.mark()) : null;
      this.dots();
      // A closed drawer asks for nothing; it calls load() when it opens.
      const dialog = this.closest('dialog');
      if (!dialog || dialog.open) this.load();
    }

    async load() {
      const addresses = (this.dataset.recommend ?? '').split(' ').filter(Boolean);
      if (addresses.length === 0 || this.loading) return;
      this.loading = true;
      const held = this.dataset.held ?? ',';
      const limit = Number(this.dataset.limit) || 4;
      for (const address of addresses) {
        if (!upsellPages.has(address)) {
          upsellPages.set(address, fetch(address).then((response) => (response.ok ? response.text() : '')).catch(() => ''));
        }
        const html = await upsellPages.get(address);
        const found = new DOMParser().parseFromString(html, 'text/html').querySelectorAll('[data-upsell-results] > li');
        // The answer may come from before the last change of the cart, so what the cart holds now is filtered again.
        const items = [...found].filter((item) => !held.includes(`,${item.dataset.upsellProduct},`)).slice(0, limit);
        if (items.length === 0) continue;
        this.list.replaceChildren(...this.leads, ...items);
        this.hidden = false;
        this.dots();
        return;
      }
    }

    // One button per card, only where there is more than one; without script the row still scrolls.
    dots() {
      const holder = this.querySelector('[data-upsell-dots]');
      const count = this.list.children.length;
      holder.hidden = count < 2;
      if (this.sizes) {
        this.sizes.disconnect();
        for (const item of this.list.children) this.sizes.observe(item);
      }
      if (count < 2) return;
      holder.replaceChildren(...[...this.list.children].map((item, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'cart-upsell__dot';
        dot.dataset.upsellDot = String(index);
        dot.setAttribute('aria-label', holder.dataset.label.replace('[index]', index + 1).replace('[count]', count));
        return dot;
      }));
      this.mark();
    }

    disconnectedCallback() {
      this.sizes?.disconnect();
    }

    current() {
      return this.list.clientWidth > 0 ? Math.round(this.list.scrollLeft / this.list.clientWidth) : 0;
    }

    mark() {
      const index = this.current();
      for (const dot of this.querySelectorAll('[data-upsell-dot]')) dot.setAttribute('aria-current', String(Number(dot.dataset.upsellDot) === index));
      const card = this.list.children[index];
      this.list.style.height = card && card.offsetHeight > 0 ? `${card.offsetHeight}px` : '';
    }

    show(index) {
      const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.list.scrollTo({ left: index * this.list.clientWidth, behavior: still ? 'auto' : 'smooth' });
    }

    choose(select) {
      const option = select.selectedOptions[0];
      const price = select.closest('[data-upsell-form]').querySelector('[data-upsell-price] .c-price');
      if (!option || !price || !window.theme) return;
      window.theme.price.update(price, { price: Number(option.dataset.price), compareAtPrice: Number(option.dataset.compare) });
    }

    async add(form) {
      const button = form.querySelector('[type="submit"]');
      if (button.getAttribute('aria-disabled') === 'true') return;
      const message = form.querySelector('[data-upsell-error]');
      const label = button.lastElementChild;
      const text = label.textContent;
      button.setAttribute('aria-disabled', 'true');
      label.textContent = this.dataset.adding;
      message.textContent = '';
      try {
        await window.theme.cart.add(new FormData(form), 'cart-upsell');
      } catch (failure) {
        message.textContent = (failure instanceof window.theme.CartError && failure.message) || this.dataset.error;
      } finally {
        // A successful add renders the cart anew; on failure this card stays and takes the next click.
        if (button.isConnected) {
          button.removeAttribute('aria-disabled');
          label.textContent = text;
        }
      }
    }
  }

  customElements.define('cart-upsell', CartUpsell);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    class FacetFilters extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-facets-dialog]');
      this.home = this.querySelector('[data-facets-home]');
      this.dialogBody = this.querySelector('[data-facets-dialog-body]');
      this.opener = this.querySelector('[data-facets-open]');
      this.bar = this.querySelector('.facets__bar');
      this.narrow = window.matchMedia('(max-width: 767px)');
      this.narrow.addEventListener('change', () => this.place());
      this.place();
      this.wake();
      this.dataset.enhanced = '';

      this.addEventListener('input', (event) => this.follow(event.target));
      this.addEventListener('change', (event) => {
        if (!event.target.form || !event.target.form.matches('[data-facets-form]')) return;
        const menu = event.target.closest('details');
        if (menu) menu.open = false;
        this.submit();
      });
      // A click beside the open sort list closes it, the way a select would.
      this.onOutside = (event) => {
        const menu = this.querySelector('.facets__bar details[open]');
        if (menu && !menu.contains(event.target)) menu.open = false;
      };
      document.addEventListener('click', this.onOutside);
      this.addEventListener('submit', (event) => {
        if (!event.target.matches('[data-facets-form]')) return;
        event.preventDefault();
        this.submit();
      });
      this.addEventListener('click', (event) => {
        const link = event.target.closest('a[data-facets-link]');
        if (link) {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.load(link.href, { push: true, toResults: link.closest('[data-facets-part="results"]') !== null });
        } else if (event.target.closest('[data-facets-open]')) {
          this.dialog.showModal();
        } else if (event.target.closest('[data-facets-close]') || event.target === this.dialog) {
          this.dialog.close();
        }
      });
      this.shown = window.location.pathname + window.location.search;
      // A jump to an anchor fires popstate as well and changes nothing the section shows.
      this.onPopState = () => {
        if (window.location.pathname + window.location.search !== this.shown) this.load(window.location.href, { push: false });
      };
      window.addEventListener('popstate', this.onPopState);
    }

    disconnectedCallback() {
      window.removeEventListener('popstate', this.onPopState);
      document.removeEventListener('click', this.onOutside);
    }

    // On narrow screens form and sorting live in the dialog, otherwise the form beside the results and the sorting above them.
    place() {
      const form = this.querySelector('[data-facets-part="form"]');
      const sort = this.querySelector('[data-facets-sort]');
      if (this.narrow.matches) {
        if (sort) this.dialogBody.append(sort);
        this.dialogBody.append(form);
      } else {
        if (this.dialog.open) this.dialog.close();
        this.home.append(form);
        if (sort) this.bar.prepend(sort);
      }
      this.opener.hidden = !this.narrow.matches;
    }

    // The price slider only writes into its two fields, so it shows once script can do that.
    wake() {
      for (const slider of this.querySelectorAll('[data-facets-slider]')) slider.hidden = false;
    }

    // Slider and field of one bound follow each other; the lower bound never passes the upper one.
    follow(target) {
      if (target.matches('[data-facets-slider-for]')) {
        const pair = [...target.parentElement.querySelectorAll('input')];
        const [low, high] = pair.map((input) => Number(input.value));
        if (low > high) target.value = target === pair[0] ? high : low;
        const field = document.getElementById(target.dataset.facetsSliderFor);
        if (field) field.value = target.value;
      } else if (target.id) {
        const slider = this.querySelector(`[data-facets-slider-for="${target.id}"]`);
        if (slider && target.value !== '') slider.value = target.value;
      }
    }

    submit() {
      const form = this.querySelector('[data-facets-form]');
      const params = new URLSearchParams();
      for (const [name, value] of new FormData(form)) {
        if (value !== '') params.append(name, value);
      }
      const query = params.toString();
      return this.load(`${form.getAttribute('action')}${query === '' ? '' : `?${query}`}`, { push: true });
    }

    async load(href, { push, toResults = false }) {
      const url = new URL(href, window.location.href);
      url.searchParams.delete('section_id');
      if (url.origin !== window.location.origin) {
        window.location.assign(url.href);
        return;
      }
      const request = new URL(url.href);
      request.searchParams.set('section_id', this.dataset.sectionId);
      if (this.controller) this.controller.abort();
      const controller = new AbortController();
      this.controller = controller;
      this.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(request.href, { signal: controller.signal });
        if (!response.ok) throw new Error(`${response.status}`);
        const fresh = new DOMParser().parseFromString(await response.text(), 'text/html').querySelectorAll('[data-facets-part]');
        if (fresh.length === 0) throw new Error('no parts');
        const focused = this.contains(document.activeElement) ? document.activeElement.id : '';
        for (const part of fresh) {
          const current = this.querySelector(`[data-facets-part="${part.dataset.facetsPart}"]`);
          if (current) current.replaceChildren(...part.childNodes);
        }
        if (push) window.history.pushState({}, '', url.href);
        this.shown = url.pathname + url.search;
        this.wake();
        const results = this.querySelector('[data-facets-part="results"]');
        const count = results.querySelector('[data-facets-count]');
        this.querySelector('[data-facets-status]').textContent = count ? count.textContent : '';
        if (toResults) {
          results.focus();
          results.scrollIntoView({ block: 'start' });
        } else if (focused !== '') {
          const again = document.getElementById(focused);
          if (again) again.focus();
        }
      } catch (error) {
        if (error.name === 'AbortError') return;
        window.location.assign(url.href);
        return;
      } finally {
        if (this.controller === controller) this.removeAttribute('aria-busy');
      }
    }
  }

  customElements.define('facet-filters', FacetFilters);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hh-bundle-upgrade"] && !Shopify.designMode) return;
  try {
    (function () {
    var KEY = 'data-exp-cart-bundle-2026-10';
    // Vorschau vor dem Start: in einem unveröffentlichten Theme wählt ?hh_exp_cart-bundle-2026-10=<arm> den Arm, auch
    // solange trybe den Test nicht als Vorschau ins Shop-Feld schreibt. Im Live-Theme (role main) wirkt das nicht.
    try {
      var role = window.Shopify && window.Shopify.theme ? window.Shopify.theme.role : 'main';
      var m = location.search.match(/[?&]hh_exp_cart-bundle-2026-10=(alt|upgrade)(&|$)/);
      if (role !== 'main' && m) {
        document.documentElement.setAttribute(KEY, m[1]);
        sessionStorage.setItem('hh-bup-preview', m[1]);
      } else if (role !== 'main' && !document.documentElement.hasAttribute(KEY) && sessionStorage.getItem('hh-bup-preview')) {
        document.documentElement.setAttribute(KEY, sessionStorage.getItem('hh-bup-preview'));
      }
    } catch (e) {}

    // Ein Klick, ein Aufruf: Shopify nimmt die Einzelprodukte heraus und legt das Bundle hinein, in einem Schritt (Zeilen
    // auf 0, die Bundle-Variante auf 1). Der Warenkorb wird einmal gezeichnet, nie leer und nie kurz über einer
    // Geschenkstufe (sonst käme z. B. das App-Geschenk ab 70 € mit). Welches Bundle per Upgrade kam, steht im
    // versteckten Warenkorb-Feld _hh_upgrade.
    document.addEventListener('click', async function (event) {
      var button = event.target.closest('[data-hh-bup]');
      if (!button || button.disabled || !window.theme) return;
      var card = button.closest('.hh-bup');
      var error = card && card.querySelector('[data-hh-bup-error]');
      var label = button.textContent;
      var updates = {};
      button.dataset.lines.split(',').filter(Boolean).forEach(function (key) { updates[key] = 0; });
      updates[button.dataset.variant] = 1;
      button.disabled = true;
      button.textContent = 'Wird umgestellt …';
      if (card) card.setAttribute('aria-busy', 'true');
      if (error) error.hidden = true;
      try {
        await window.theme.cart.update({ updates: updates, attributes: { _hh_upgrade: button.dataset.handle } }, 'bundle-upgrade');
      } catch (e) {
        if (!button.isConnected) return;
        if (error) error.hidden = false;
        if (card) card.removeAttribute('aria-busy');
        button.textContent = label;
        button.disabled = false;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["legal-guarantee"] && !Shopify.designMode) return;
  try {
    (function () {
    // Delegated and looked up per click: the cart drawer re-renders its trigger through the section API.
    document.addEventListener('click', (event) => {
      const dialog = document.querySelector('[data-legal-guarantee]');
      if (!dialog || !dialog.showModal) return;
      if (event.target.closest('[data-legal-guarantee-open]')) {
        event.preventDefault();
        dialog.showModal();
      } else if (event.target === dialog || event.target.closest('[data-legal-guarantee-close]')) {
        dialog.close();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pack-rows"] && !Shopify.designMode) return;
  try {
    // Every part of the rows names the chosen pack: the panel of that quantity shows, the others hide.
  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.name !== 'quantity' || !input.closest('.c-pack-options--rows')) return;
    const form = input.getAttribute('form');
    for (const panel of document.querySelectorAll('[data-pack-panel]')) {
      if (panel.dataset.packForm === form) panel.hidden = panel.dataset.packQuantity !== input.value;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-field"] && !Shopify.designMode) return;
  try {
    class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-search-input]');
      this.list = this.querySelector('[data-search-list]');
      this.status = this.querySelector('[data-search-status]');
      this.active = -1;
      // Without script the field is a plain search input, so the combobox role arrives with the script.
      this.input.setAttribute('role', 'combobox');
      this.input.setAttribute('aria-autocomplete', 'list');
      this.input.setAttribute('aria-controls', this.list.id);
      this.input.setAttribute('aria-expanded', 'false');

      this.input.addEventListener('input', () => this.schedule());
      this.input.addEventListener('keydown', (event) => this.onKeyDown(event));
      // A press on a suggestion must not take the focus out of the field before the click lands.
      this.list.addEventListener('mousedown', (event) => event.preventDefault());
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.close();
      });
    }

    options() {
      return [...this.list.querySelectorAll('[role="option"]')];
    }

    schedule() {
      clearTimeout(this.timer);
      const terms = this.input.value.trim();
      if (terms.length < 2) {
        if (this.controller) this.controller.abort();
        this.close();
        return;
      }
      this.timer = setTimeout(() => this.suggest(terms), 250);
    }

    async suggest(terms) {
      if (this.controller) this.controller.abort();
      const controller = new AbortController();
      this.controller = controller;
      this.status.textContent = this.dataset.loading;
      const params = new URLSearchParams({
        q: terms,
        'resources[type]': 'query,product,collection,article,page',
        'resources[limit]': '4',
        'resources[limit_scope]': 'each',
        section_id: 'predictive-search',
      });
      try {
        const response = await fetch(`${this.dataset.url}?${params}`, { signal: controller.signal });
        if (!response.ok) throw new Error(`${response.status}`);
        const fresh = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-predictive-results]');
        if (!fresh) throw new Error('no results');
        if (this.input.value.trim() !== terms) return;
        this.list.replaceChildren(...fresh.childNodes);
        this.options().forEach((option, index) => {
          option.id = `${this.list.id}-option-${index}`;
        });
        this.status.textContent = fresh.dataset.status;
        this.open();
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.status.textContent = '';
        this.close();
      }
    }

    open() {
      this.list.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
      this.select(-1);
    }

    close() {
      clearTimeout(this.timer);
      this.select(-1);
      this.list.hidden = true;
      this.list.replaceChildren();
      this.input.setAttribute('aria-expanded', 'false');
    }

    select(index) {
      const options = this.options();
      options.forEach((option, position) => option.setAttribute('aria-selected', position === index ? 'true' : 'false'));
      this.active = index;
      if (index === -1) {
        this.input.removeAttribute('aria-activedescendant');
        return;
      }
      this.input.setAttribute('aria-activedescendant', options[index].id);
      options[index].scrollIntoView({ block: 'nearest' });
    }

    onKeyDown(event) {
      const options = this.options();
      if (this.list.hidden || options.length === 0) return;
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        this.select(this.active + 1 >= options.length ? 0 : this.active + 1);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        this.select(this.active <= 0 ? options.length - 1 : this.active - 1);
      } else if (event.key === 'Enter' && this.active !== -1) {
        event.preventDefault();
        window.location.assign(options[this.active].querySelector('a').href);
      } else if (event.key === 'Escape') {
        // The first Escape closes the suggestions only; whatever surrounds the field hears the next one.
        event.preventDefault();
        event.stopPropagation();
        this.close();
      }
    }
  }

  customElements.define('predictive-search', PredictiveSearch);
  } catch(e) { console.error(e); }
})();

})();
